import axios from "axios";
import Key from "../../clientVariables.json";
import * as types from "../OptimiseResume/ResumeBuilderActions/actiontypes";
import { fetchAdvancedOptimize } from "./advancedOptimizeApi";
import {
  buildCandidateData,
  flattenOptimizedSkills,
  getJobDescriptionText,
  mapOptimizedToResumeFullDetails,
} from "./resumeDataUtils";

export const executeAdvancedOptimise = async ({ resumeId, jobDescription, userId }) => {
  const response = await axios.post(`${Key.domain}/common/get_js_resume_details`, {
    user_id: userId || null,
    resumeid: resumeId,
  });

  const resumeData = response?.data?.data;
  if (!resumeData?.resumedetails) {
    throw new Error("Could not load candidate resume details.");
  }

  const jdText =
    typeof jobDescription === "string"
      ? jobDescription
      : getJobDescriptionText(jobDescription);

  if (!jdText) {
    throw new Error("Job description is required for advanced optimisation.");
  }

  const candidateData = buildCandidateData(resumeData);
  const optimizedData = await fetchAdvancedOptimize(jdText, candidateData);
  const resumeFullDetails = mapOptimizedToResumeFullDetails(resumeData, optimizedData);

  return { optimizedData, resumeFullDetails };
};

export const hydrateAdvancedOptimiseStore = (dispatch, contextObject, payload) => {
  const { optimizedData, resumeFullDetails } = payload;
  const allSkills = flattenOptimizedSkills(optimizedData);
  const projectdetails = resumeFullDetails.projectdetails || [];

  dispatch({
    type: types.SET_CURRENT_SECTION,
    payload: { section: "", id: 0, isRedirect: false },
  });
  dispatch({
    type: types.JS_FULL_RESUME_DETAILS_SUCCESS,
    payload: {
      ...resumeFullDetails,
      resumedetails: {
        ...(resumeFullDetails?.resumedetails || {}),
        ai_skills: allSkills.join(", "),
      },
      projectdetails,
    },
  });
  dispatch({
    type: types.RESUMES_PROJECTS_DATA,
    payload: projectdetails,
  });
  dispatch({
    type: types.UPDATE_PROJECTS,
    payload: projectdetails,
  });
  dispatch({
    type: types.UPDATE_SKILLS,
    payload: optimizedData?.skills || [],
  });

  if (contextObject) {
    contextObject.updateSummary?.(optimizedData?.summary || "");
    contextObject.updateJobTitle?.(resumeFullDetails.resumedetails?.application_title || "");
    contextObject.updateExperience?.(resumeFullDetails.resumedetails?.total_experience || "");
    contextObject.updateAISkills?.([...allSkills]);
  }
};

/** Clears shared store/context so normal optimiser flow is unaffected after leaving advanced page. */
export const clearAdvancedOptimiseStore = (dispatch, contextObject) => {
  dispatch({ type: types.RESET_RESUME });

  if (contextObject) {
    contextObject.updateSummary?.("");
    contextObject.updateJobTitle?.("");
    contextObject.updateExperience?.("");
    contextObject.updateAISkills?.([]);
  }
};
